import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';

/**
 * For the signed-out pages (new-login, new-register, new-forgot-password):
 * someone already signed in goes straight to new-home instead.
 */
export const newGuestGuard: CanActivateFn = () => {
  const signedIn = !!localStorage.getItem('ALTOMATE_ACCESS_TOKEN_KEY');
  return signedIn ? inject(Router).parseUrl('/new-home') : true;
};
